module.exports = __webpack_public_path__ + "static/media/pills2x.1ea17cf7.png";